import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { GrMail } from "react-icons/gr";

const Footer = () => {
  return (
    <footer className="footerGlass">
      <div className="footerContent">
        <div className="footerInfo">
          <h4>Developed by Nguyen Dang Trung</h4>
          <span className="footerDivider">•</span>
          <h4>Copyright &copy; 2026 trungcrbay</h4>
        </div>
        <div className="footerLinks">
          <a
            href="https://github.com/trungcrbay"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub Profile"
            className="footerSocialIcon"
            title="Visit my GitHub"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/trungcrbay/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn Profile"
            className="footerSocialIcon"
            title="Connect on LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href="mailto:trungnguyenjr123@gmail.com"
            target="_blank"
            rel="noreferrer"
            aria-label="Email"
            className="footerSocialIcon"
            title="Send an Email"
          >
            <GrMail />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
